/**
 * Created by Arif Topcu in 2019
 */

import SecurityAttributeComplication from './SecurityAttributeComplication';

export default SecurityAttributeComplication;
